/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ComponentSchema } from './ComponentSchema';
import {
    ComponentSchemaFromJSON,
    ComponentSchemaFromJSONTyped,
    ComponentSchemaToJSON,
} from './ComponentSchema';

/**
 * 
 * @export
 * @interface Vpc
 */
export interface Vpc {
    /**
     * 
     * @type {number}
     * @memberof Vpc
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof Vpc
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof Vpc
     */
    updated: Date;
    /**
     * 
     * @type {ComponentSchema}
     * @memberof Vpc
     */
    component: ComponentSchema;
    /**
     * 
     * @type {string}
     * @memberof Vpc
     */
    arn?: string;
    /**
     * 
     * @type {string}
     * @memberof Vpc
     */
    vpcId?: string;
}

/**
 * Check if a given object implements the Vpc interface.
 */
export function instanceOfVpc(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "component" in value;

    return isInstance;
}

export function VpcFromJSON(json: any): Vpc {
    return VpcFromJSONTyped(json, false);
}

export function VpcFromJSONTyped(json: any, ignoreDiscriminator: boolean): Vpc {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'component': ComponentSchemaFromJSON(json['component']),
        'arn': !exists(json, 'arn') ? undefined : json['arn'],
        'vpcId': !exists(json, 'vpc_id') ? undefined : json['vpc_id'],
    };
}

export function VpcToJSON(value?: Vpc | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'component': ComponentSchemaToJSON(value.component),
        'arn': value.arn,
        'vpc_id': value.vpcId,
    };
}

